import { type CheckboxChangeEvent } from 'antd/es/checkbox';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import {
  getItem as getLocalStorageItem,
  removeItem as removeLocalStorageItem,
  setItem as setLocalStorageItem,
} from 'utils/storage';

import { StyledCheckbox, StyledNotification } from './ReleaseNotification.style';

// update these to new values each quarter
export const storageKey = `q4-2025-release-notification-dismissed`;
export const highlightText = `Check out work container email notifications, dark mode, and more.`;
export const releaseNotesURL = `https://support.skyspecs.com/hc/en-us/articles/45842640817683-Q4-2025-Horizon-Release`;

export const shouldShowReleaseNotification = (): boolean => {
  return getLocalStorageItem(storageKey) !== 'true';
};

const FeatureNotificationContent: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const handleTogglePermanentDismissal = (event: CheckboxChangeEvent) => {
    if (event.target.checked) {
      setLocalStorageItem(storageKey, 'true');
    } else {
      removeLocalStorageItem(storageKey);
    }
  };

  return (
    <>
      <p>
        {highlightText}
        <br />
        <a href={releaseNotesURL} target="_blank" rel="noreferrer">
          {t('releaseNotification.seeReleaseNotes', 'See release notes for more info.')}
        </a>
      </p>
      <StyledCheckbox onChange={handleTogglePermanentDismissal}>
        {t('releaseNotification.dontShowAgain', "Don't show again")}
      </StyledCheckbox>
    </>
  );
};

export const getReleaseNotificationConfig = () => ({
  message: (
    <StyledNotification>
      {i18n.t('releaseNotification.newFeaturesReleased', 'New Features Released!')}
    </StyledNotification>
  ),
  description: <FeatureNotificationContent />,
  duration: 0,
  placement: 'bottomRight',
  classNames: 'new-feature-notification',
});
